import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { isOfflineDevelopment } from '~/utils'

export function createInsights() {
  if (isOfflineDevelopment)
    return
  const appInsights = new ApplicationInsights({
    config: {
      connectionString: import.meta.env.VITE_APP_INSIGHTS_CONNECTION_STRING,
      appId: import.meta.env.VITE_APP_ID,
      enableAutoRouteTracking: true,
      disableFetchTracking: false,
    },
  })

  appInsights.loadAppInsights()

  return appInsights
}
